import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function faqService() {
  function getFaqs(params) {
    return http.get('/v1/faq', {
      params,
      ...OPTIONS_INTEGRATION,
    })
  }

  function sendFaqVote(id, body) {
    return http.patch(`/v1/faq/${id}/feedback`, body, OPTIONS_INTEGRATION)
  }

  function getFaqSearch(input) {
    return http.get(`/v1/faq/search-ai`, {
      params: { input },
      ...OPTIONS_INTEGRATION,
    })
  }

  function getFunctionCallingResponse(input) {
    return http.get('/v1/ai/function-calling', { params: { input }, ...OPTIONS_INTEGRATION })
  }

  return {
    getFaqs,
    sendFaqVote,
    getFaqSearch,
    getFunctionCallingResponse,
  }
}
